import store from '@/store'

const filterDuplicates = (array, key) => {
	return array.filter(
		(obj, index, self) => index === self.findIndex((o) => o[key] === obj[key]),
	)
}

class GeneralHelper {
	static async getAllAccountslive() {
		try {
			const response = await fetch(
				`${process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS}/list/checkaccounts`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
						Authorization: `Bearer ${store.state.token}`,
					},
				},
			)

			if (!response.ok) {
				throw new Error('Failed to fetch live accounts')
			}

			const data = await response.json()
			const filteredData = filterDuplicates(data.response, 'login')
			localStorage.setItem('AccountsLive', JSON.stringify(filteredData))

			window.dispatchEvent(
				new CustomEvent('live-accounts-localstorage-changed', {
					detail: {
						storage: localStorage.getItem('AccountsLive'),
					},
				}),
			)

			return filteredData
		} catch (error) {
			console.error(error)
			localStorage.setItem('AccountsLive', '[]')

			return []
		}
	}

	static async getAllAccountsDemo() {
		try {
			const response = await fetch(
				`${process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS}/list/checkdemoaccounts`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
						Authorization: `Bearer ${store.state.token}`,
					},
				},
			)

			if (!response.ok) {
				throw new Error('Failed to fetch demo accounts')
			}

			const data = await response.json()
			const filteredData = filterDuplicates(data.response, 'login')
			localStorage.setItem('DemoAccounts', JSON.stringify(filteredData))

			window.dispatchEvent(
				new CustomEvent('demo-accounts-localstorage-changed', {
					detail: { storage: localStorage.getItem('DemoAccounts') },
				}),
			)

			return filteredData
		} catch (error) {
			console.error(error)
			localStorage.setItem('DemoAccounts', '[]')

			return []
		}
	}
}

export { GeneralHelper }
